import _ from 'lodash';

import { APIClient } from './APIClient';
import TokenStore from "../stores/TokenStore";

class AmazonPayAPIClient extends APIClient {

    additionalHeaders = {};

    getHeaders() {
        return {
            ...super.getHeaders(),
            ..._.pickBy({
                'x-customer-device': TokenStore.getDevice(),
                ...this.additionalHeaders
            }, _.isString)
        };
    }

    wrapHeaders (func, additionalHeaders) {
        this.setAdditionalHeaders(additionalHeaders);
        const response = func();
        this.setAdditionalHeaders(null);

        return response;
    }

    delete (path, data = null, options = {}, additionalHeaders = null, authenticated = false) {
        if (authenticated) {
            additionalHeaders = {
                ...additionalHeaders,
                'x-customer-token': TokenStore.getCustomer()
            };
        }

        return this.wrapHeaders(() =>
            super.delete(path, data, options),
            additionalHeaders);
    }

    get (path, data = null, options = {}, additionalHeaders = null) {
        return this.wrapHeaders(() =>
            super.get(path, data, options),
            additionalHeaders);
    }

    post(path, data = {}, options = {}, additionalHeaders = null) {
        return this.wrapHeaders(() =>
            super.post(path, data, options),
            additionalHeaders);
    }

    put(path, data = {}, options = {}, additionalHeaders = null) {
        return this.wrapHeaders(() =>
            super.put(path, data, options),
            additionalHeaders);
    }

    setAdditionalHeaders(headers) {
        this.additionalHeaders = headers;
    }
}


export default new AmazonPayAPIClient();



// WEBPACK FOOTER //
// ./src/lib/AmazonAPIClient.js